/* eslint-disable react/prop-types -- this codebase does not use propTypes (see CLAUDE.md). */
// The one rounded badge used across the dashboard and the redesigned screens.
//
// size:
//   - "md" (default): status and role badges (Team, Settings). Content is
//     centred so a badge given a min-width keeps its label in the middle.
//   - "sm": the dashboard's change pills (↑ 12%), a little tighter.
//
// tone: the change pills use good / bad / muted; the status and role badges use
// dark / indigo / neutral / orange / green. "muted" and "neutral" are both gray
// and differ only in text weight (gray-600 vs gray-800), as do "good" and
// "green" (emerald-700 vs emerald-800).
const TONES = {
  good: "bg-emerald-50 text-emerald-700",
  bad: "bg-red-50 text-red-700",
  muted: "bg-gray-100 text-gray-600",
  dark: "bg-gray-900 text-white",
  indigo: "bg-indigo-50 text-indigo-800",
  neutral: "bg-gray-100 text-gray-800",
  orange: "bg-orange-50 text-orange-800",
  green: "bg-emerald-50 text-emerald-800",
};

const SIZES = {
  sm: "px-2",
  md: "justify-center px-2.5",
};

function pillClass(tone, size = "md") {
  return `inline-flex items-center rounded-full py-0.5 text-xs font-semibold whitespace-nowrap ${SIZES[size] || SIZES.md} ${TONES[tone] || TONES.neutral}`;
}

export function Pill({ tone, size, srText, className = "", children }) {
  return (
    <span
      className={`${pillClass(tone, size)}${className ? ` ${className}` : ""}`}
    >
      {srText && <span className="sr-only">{srText} </span>}
      {children}
    </span>
  );
}
